<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <div id="landBaseMap" style="width: 100%;height: 70vh;border-radius: 10px;"></div>
    </card>

  </div>
</template>
<style>
/*地图标点样式*/
.amap-icon img {
  /*width: 25px;*/
  /*height: 34px;*/
}
/*地图标点文本父元素样式*/
.amap-marker-label{
  border: 0;
  background-color: transparent;
}
/*地图标点文本元素样式*/
.info{
  position: relative;
  margin:0;
  top: 0;
  right: 0;
  min-width: 0;
  padding: .75rem 1.25rem;
  border-radius: .25rem;
  background-color: white;
  width: auto;
  border-width: 0;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
}
</style>
<script>
import {landBaseListAllApi} from '@/api/landBase/landBase'
import {initAMap} from '@/components/common/amapHelper'

export default {
  name: 'landBaseMap',
  data() {
    return {

    }
  },
  mounted() {
    this.loadMap()
  },
  methods: {

    // 加载地图组件
    loadMap(){
      // 调用接口查询
      landBaseListAllApi().then(async res => {
        if (res.code === 200) {
          let location = [110.308684, 37.159286]
          let locationTime = '';
          if (res.data.length === 0) {
            this.$Message.error('暂无基地信息')
          }

          // 初始化地图
          const AMap = await initAMap();
          // 创建地图 卫星地图
          let map = new AMap.Map("landBaseMap", {
            resizeEnable: true,
            center: location,
            zoom: 10.6,
            // 设置为卫星图层
            layers: [
              // 卫星
              new AMap.TileLayer.Satellite(),
              // 路网
              new AMap.TileLayer.RoadNet()
            ],
            //
          });

          if (res.data.length !== 0) {
            // 循环数据
            for (let i = 0; i < res.data.length; i++) {

              let landBaseData = res.data[i];
              if (landBaseData.lng === null || landBaseData.lat === null || landBaseData.lng === '' || landBaseData.lat === '') {
                continue;
              }
              // 在高德地图上创建点信息
              let marker = new AMap.Marker({
                map: map,
                position: [landBaseData.lng, landBaseData.lat],
                offset: new AMap.Pixel(-13, -30),
                label: {
                  content: `<div class='info'>${landBaseData.title}</div>`,
                  direction: 'bottom',
                  offset: new AMap.Pixel(0, -75),
                },
              })
            }

          }

        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
